<template>
  <div class="stu">
    <el-form ref="form" :model="form1" label-width="70px" :inline="true" size="mini">
      <el-form-item label="审核状态">
        <el-select v-model="form1.check_state" placeholder="请选择活动区域" clearable>
          <el-option label="通过" value="1"></el-option>
          <el-option label="未通过" value="0"></el-option>
          <el-option label="未审核" value="null"></el-option>

        </el-select>

      </el-form-item>

      <el-button type="primary" @click="adminGetOjContestSignList" icon="el-icon-search" size="mini">查询</el-button>

    </el-form>
    <el-button type="primary" @click="addstu" size="mini">添加用户</el-button>
    <el-button type="primary" @click="isCheck2" size="mini">批量审核通过</el-button>
    <el-button type="primary" @click="isCheck3" size="mini">批量审核不通过</el-button>
    <el-button type="primary" @click="dels" size="mini">批量删除</el-button>

    <div>
      <el-table :data="tableData" size="mini" stripe style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange1">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="realname" label="姓名">
          <template slot-scope="scope">
            <span v-if="scope.row.user_id === null">{{scope.row.realname}} <span style="color:#FCBB30">(学生)</span></span>
            <span v-else>{{scope.row.realname}} <span style="color:#FCBB30">(教师)</span></span>

          </template>
        </el-table-column>
        <el-table-column prop="schoolName" label="所属校区">
        </el-table-column>
        <el-table-column prop="check_state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.check_state === 1">已通过</span>
            <span v-if="scope.row.check_state === 0">未通过</span>
            <span v-if="scope.row.check_state === null">未审核</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="scope.row.check_state === 1" @click="isCheck(scope.row)">已通过</el-button>
            <el-button type="text" size="mini" v-if="scope.row.check_state === 0" @click="isCheck1(scope.row)">未通过</el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="80%" top="5vh">
      <el-tabs v-model="activeName">
        <el-tab-pane label="学生列表" name="first">
          <el-form ref="form" :model="form" label-width="70px" :inline="true" size="mini">
            <el-form-item label="学生账号">
              <el-input v-model="form.username" clearable></el-input>
            </el-form-item>

            <el-button type="primary" @click="adminGetStuListForAddContestUser" icon="el-icon-search" size="mini">查询</el-button>

          </el-form>
          <el-table :data="tableData1" size="mini" stripe style="width: 100%;margin-top:20px" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="账号">
            </el-table-column>
            <el-table-column prop="realName" label="姓名">

            </el-table-column>
            <el-table-column prop="schoolName" label="校区">

            </el-table-column>

          </el-table>

          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
            </el-pagination>
          </div>
          <div class="fr">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="教师列表" name="second">
          <el-form ref="form" :model="form2" label-width="70px" :inline="true" size="mini">
            <el-form-item label="老师账号">
              <el-input v-model="form2.username" clearable></el-input>
            </el-form-item>

            <el-button type="primary" @click="adminGetUserListForAddContestUser" icon="el-icon-search" size="mini">查询</el-button>

          </el-form>
          <el-table :data="tableData2" size="mini" stripe style="width: 100%;margin-top:20px" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange3">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="账号">
            </el-table-column>
            <el-table-column prop="realName" label="姓名">

            </el-table-column>
            <el-table-column prop="schoolName" label="校区">

            </el-table-column>

          </el-table>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent2" :current-page="page_no2" :page-size="page_size2" layout="total, prev, pager, next, jumper" :total="total2">
            </el-pagination>
          </div>
          <div class="fr">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit1">确 定</el-button>
          </div>

        </el-tab-pane>

      </el-tabs>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span> -->

    </el-dialog>
  </div>
</template>

<script>
import {
  adminGetOjContestSignList,
  adminGetStuListForAddContestUser,
  adminAddContestSign,
  adminUpdateContestSignCheckState,
  adminGetUserListForAddContestUser,
  adminDeleteContestSign

}
  from "@/api/adminOj.js";
export default {
  data() {
    return {
      page_no2: 1,
      page_size2: 20,
      total2: 20,
      form2: {},
      tableData2: [],
      form1: {},
      form: {},
      dialogVisible: false,
      activeName: 'first',
      tableData1: [],
      contest_id: '',
      tableData: [],
      page_no: 1,
      page_size: 20,
      total: 20,
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      multipleSelection: [],
      multipleSelection1: [],
      multipleSelection2: []

    }
  },
  created() {
    this.contest_id = this.$route.query.contest_id
  },
  mounted() {
    this.adminGetOjContestSignList()
  },
  methods: {
    del(row) {
      console.log(row.id)
      let ids = []
      ids.push(row.id)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteContestSign({
          contestSignIds: JSON.stringify(ids)
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.adminGetOjContestSignList()

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    dels() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning('请选中再进行删除!')
        return false
      }
      adminDeleteContestSign({
        contestSignIds: JSON.stringify(this.multipleSelection1)
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.adminGetOjContestSignList()

      })
    },
    isCheck2() {
      adminUpdateContestSignCheckState({
        contestSignIds: JSON.stringify(this.multipleSelection1),
        check_state: 1
      }).then((res) => {
        console.log(res)
        this.$message.success('修改成功')
        this.adminGetOjContestSignList()

      })


    },
    isCheck3() {
      adminUpdateContestSignCheckState({
        contestSignIds: JSON.stringify(this.multipleSelection1),
        check_state: 0
      }).then((res) => {
        console.log(res)
        this.$message.success('修改成功')
        this.adminGetOjContestSignList()

      })


    },
    isCheck(row) {
      adminUpdateContestSignCheckState({
        contestSignIds: JSON.stringify([row.id]),
        check_state: 0
      }).then((res) => {
        console.log(res)
        this.$message.success('修改成功')
        this.adminGetOjContestSignList()

      })


    },
    isCheck1(row) {
      adminUpdateContestSignCheckState({
        contestSignIds: JSON.stringify([row.id]),
        check_state: 1
      }).then((res) => {
        console.log(res)
        this.$message.success('修改成功')
        this.adminGetOjContestSignList()

      })


    },
    submit1() {
      adminAddContestSign({
        contest_id: this.contest_id,
        userInfoArr: JSON.stringify(this.multipleSelection2),
        userRole: 2
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功！')
        this.dialogVisible = false
        this.adminGetOjContestSignList()
      })

    },
    submit() {
      adminAddContestSign({
        contest_id: this.contest_id,
        userInfoArr: JSON.stringify(this.multipleSelection),
        userRole: 1
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功！')
        this.dialogVisible = false
        this.adminGetOjContestSignList()
      })
    },
    handleSelectionChange3(val) {
      let arr = []
      this.multipleSelection2 = [];
      for (let k = 0; k < val.length; k++) {

        let obg = {
          code: val[k].code,
          id: val[k].id,
          schoolId: val[k].schoolId

        }
        arr.push(obg);
        console.log(arr, 111)
        this.multipleSelection2 = arr
      }
      console.log(this.multipleSelection2)

    },
    handleSelectionChange(val) {
      console.log(val)
      let arr = []
      this.multipleSelection = [];
      for (let k = 0; k < val.length; k++) {

        let obg = {
          code: val[k].code,
          id: val[k].id,
          schoolId: val[k].schoolId

        }
        arr.push(obg);
        console.log(arr, 111)
        this.multipleSelection = arr
      }
      console.log(this.multipleSelection)


    },
    handleSelectionChange1(val) {
      console.log(val)
      let arr = []
      this.multipleSelection1 = [];
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id);
        console.log(arr)
        this.multipleSelection1 = arr
      }
      console.log(this.multipleSelection1)

    },
    //获取比赛学生列表
    adminGetOjContestSignList() {
      adminGetOjContestSignList({
        ...this.form1,
        contest_id: this.contest_id,
        page_no: this.page_no,
        page_size: this.page_size
      }).then((res) => {
        console.log(res)
        this.tableData = res.OjContestSignList
        this.total = res.total
      })
    },
    handleCurrent(val) {
      this.page_no = val
      this.adminGetOjContestSignList()
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.adminGetStuListForAddContestUser()
    },
    addstu() {
      this.dialogVisible = true
      this.adminGetStuListForAddContestUser()
      this.adminGetUserListForAddContestUser()
    },
    adminGetStuListForAddContestUser() {
      adminGetStuListForAddContestUser({
        ...this.form,
        contest_id: this.contest_id,
        page_no: this.page_no1,
        page_size: this.page_size1
      }).then((res) => {
        console.log(res)
        this.tableData1 = res.studentList
        this.total1 = res.total
      })
    },

    adminGetUserListForAddContestUser() {
      adminGetUserListForAddContestUser({
        ...this.form2,
        contest_id: this.contest_id,
        page_no: this.page_no2,
        page_size: this.page_size2
      }).then((res) => {
        console.log(res)
        this.tableData2 = res.userList
        this.total2 = res.total
      })
    },
    handleCurrent2(val) {
      this.page_no2 = val
      this.adminGetUserListForAddContestUser()
    }
  }

}
</script>

<style lang="scss" scoped>
.stu {
  margin: 10px;
  padding: 20px;
  min-height: 100vh;

  background: white;
  border-radius: 5px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
.top {
  font-size: 18px;
  font-weight: 300;
}
/deep/ .el-radio-group {
  margin-top: 7px;
}
/deep/ .el-divider--horizontal {
  margin-top: 0px;
}
</style>